import * as form from '../form';

export const substanceDrugVoluntary = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        DrugType: form.radio(xitem.DrugType),
        TreatmentProvider: form.name(xitem.TreatmentProvider),
        TreatmentProviderNotApplicable: form.notapplicable(xitem.TreatmentProviderNotApplicable),
        TreatmentProviderAddress: form.location(xitem.TreatmentProviderAddress),
        TreatmentProviderTelephone: form.telephone(xitem.TreatmentProviderTelephone),
        TreatmentDates: form.daterange(xitem.TreatmentDates),
        TreatmentCompleted: form.branch(xitem.TreatmentCompleted),
        NoTreatmentExplanation: form.textarea(xitem.NoTreatmentExplanation),
        Comments: form.textarea(xitem.Comments),
        NoTreatmentComments: form.textarea(xitem.NoTreatmentComments),
        RecommendedBy: form.checkboxgroup(xitem.RecommendedBy), // PVQ Only
        RecommendedOther: form.textarea(xitem.RecommendedOther), // PVQ Only
        DueToDrugs: form.branch(xitem.DueToDrugs), // PVQ Only
        DrugTypeOther: form.textarea(xitem.DrugTypeOther), // PVQ Only
        DrugTypes: form.checkboxgroup(xitem.DrugTypes), // PVQ Only
        DueToPrescription: form.branch(xitem.DueToPrescription), // PVQ Only
        PrescriptionDrug: form.text(xitem.PrescriptionDrug), // PVQ Only
        TreatmentProviderInPractice: form.branch(xitem.TreatmentProviderInPractice), // PVQ Only
        TreatmentProviderPracticeName: form.text(xitem.TreatmentProviderPracticeName), // PVQ Only
        TreatmentProviderPracticeNameNotApplicable: form.notapplicable(xitem.TreatmentProviderPracticeNameNotApplicable), // PVQ Only
        TreatmentProviderTelephones: form.collection(form.telephoneCollection(xitem.TreatmentProviderTelephones)), // PVQ Only
        TreatmentProviderEmails: form.collection(form.emailCollection(xitem.TreatmentProviderEmails)), // PVQ Only
        TreatmentStatus: form.textarea(xitem.TreatmentStatus), // PVQ Only
      },
    };
  });
  return {
    TreatmentVoluntary: form.branch(data.TreatmentVoluntary),
    List: form.collection(items, (data.List || {}).branch),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
  };
};
